<template>
  <Container as="header" data-component="NewsItemHeader" class="flex flex-col mt-4 lg:mt-0">
    <Grid>
      <div class="col-span-12 lg:col-span-8 lg:col-start-3">
        <div class="flex flex-col gap-3 lg:gap-4 max-w-[760px]">
          <!-- Tags -->
          <div v-if="tagItems && tagItems.length" class="flex flex-wrap gap-2">
            <CustomNuxtLink
              v-for="(tag, index) in tagItems"
              :key="`${tag.title}-${index}`"
              :to="tag.url ?? undefined"
              class="bg-primary-100 text-white rounded-lg px-2.5 py-1">
              <Typography as="span" variant="caption-small" class="font-medium leading-none">{{ tag.title }}</Typography>
            </CustomNuxtLink>
          </div>

          <!-- Title -->
          <Typography as="h1" variant="header-1" class="text-primary-100">{{ title }}</Typography>

          <!-- Actueel - publicatiedatum - plaats -->
          <Typography as="p" variant="header-4" class="text-primary-100">
            Actueel<template v-if="formattedDate"> – {{ formattedDate }}</template><template v-if="area"> – {{ area }}</template>
          </Typography>

          <!-- Introduction -->
          <Typography
            v-if="introduction"
            as="p"
            variant="header-5"
            class="text-primary-100">{{ introduction }}</Typography>
        </div>
      </div>
      <!-- Image -->
      <div class="col-span-12 lg:col-span-10 lg:col-start-2">
        <div v-if="image" class="rounded-2xl overflow-hidden aspect-[16/9]">
          <Image
            :image="image"
            fit="cover"
            class="w-full h-full" />
        </div>
      </div>
    </Grid>
  </Container>
</template>

<script setup lang="ts">
import { formatPublicationDate } from '@corporate/utils/date'
import type { NewsItemHeaderApiModel } from '@gro-up/api/corporate'
import { Container, Typography, Image, Grid, CustomNuxtLink } from '@gro-up/ui/primitives'
import { computed } from 'vue'

type NewsItemHeaderBlockProps = NewsItemHeaderApiModel

const props = defineProps<NewsItemHeaderBlockProps>()

const formattedDate = computed(() => formatPublicationDate(props.publicationDate))
</script>
